import gql from 'graphql-tag';

export const CAPABILITIES = gql`
    query capabilities($projectId: Int64!) {
        capabilities(projectId: $projectId) {
            id
            name
            description
            project_id
        }
    }
`;

export const PAGINATED_CAPABILITIES = gql`
    query paginatedCapabilities($projectId: Int64!, $filters: FiltersInput) {
        paginatedCapabilities(projectId: $projectId, filters: $filters) {
            data {
                id
                name
                description
                project_id
            }
            pagination {
                current_page
                last_page
                total
                per_page
            }
        }
    }
`;

export const ENCODERS = gql`
    query encoders($projectId: Int64!) {
        encoders(projectId: $projectId) {
            id
            name
            project_id
        }
    }
`;

export const ENCODER = gql`
    query encoder($projectId: Int64!, $encoderId: Int64!) {
        encoder(projectId: $projectId, encoderId: $encoderId) {
            id
            name
            protocol_id
            function_id
            Parameters
            project_id
        }
    }
`;

export const PROJECT_ENCODERS = gql`
    query projectEncoders($projectId: Int64!, $filters: FiltersInput) {
        projectEncoders(projectId: $projectId, filters: $filters) {
            data {
                id
                name
                protocol_id
                function_id
                Parameters
                project_id
            }
            pagination {
                current_page
                last_page
                total
                per_page
            }
        }
    }
`;

export const FUNCTIONS = gql`
    query functions($projectId: Int64!) {
        functions(projectId: $projectId) {
            id
            description
            language
            has_file_set
            invoke_url
            file_upload_url
        }
    }
`;

export const FUNCTION = gql`
    query function($projectId: Int64!, $functionId: String!) {
        function(projectId: $projectId, functionId: $functionId) {
            id
            description
            language
            has_file_set
            invoke_url
            file_upload_url
        }
    }
`;

export const FUNCTION_EXECUTIONS = gql`
    query functionExecutions($projectId: Int64!, $functionId: String!, $filters: FiltersInput) {
        functionExecutions(projectId: $projectId, functionId: $functionId, filters: $filters) {
            data {
                source
                started_at
                execution_time
                log
                error
            }
            pagination {
                current_page
                last_page
                total
                per_page
            }
        }
    }
`;

export const FUNCTION_EXECUTION_STATS = gql`
    query functionExecutionStats($projectId: Int64!, $functionId: String!) {
        functionExecutionStats(projectId: $projectId, functionId: $functionId) {
            total
            sample
            success
            errors
            error_rate
            avg_execution_time
            min_execution_time
            max_execution_time
            p95_execution_time
            sources {
                source
                count
            }
        }
    }
`;

export const ENCODER_PROTOCOLS = gql`
    query encoderProtocols {
        encoderProtocols {
            id
            name
            topic
        }
    }
`;

export const STORE_CAPABILITY = gql`
    mutation storeCapability($projectId: Int64!, $input: CapabilityInput!) {
        storeCapability(projectId: $projectId, input: $input) {
            id
            name
            description
            project_id
        }
    }
`;

export const UPDATE_CAPABILITY = gql`
    mutation updateCapability($projectId: Int64!, $capabilityId: Int64!, $input: CapabilityInput!) {
        updateCapability(projectId: $projectId, capabilityId: $capabilityId, input: $input) {
            id
            name
            description
            project_id
        }
    }
`;

export const DELETE_CAPABILITY = gql`
    mutation deleteCapability($projectId: Int64!, $capabilityId: Int64!) {
        deleteCapability(projectId: $projectId, capabilityId: $capabilityId) {
            id
        }
    }
`;

export const CREATE_ENCODER = gql`
    mutation createEncoder($projectId: Int64!, $input: CreateEncoderInput!) {
        createEncoder(projectId: $projectId, input: $input) {
            id
            name
            protocol_id
            function_id
            Parameters
            project_id
        }
    }
`;

export const UPDATE_ENCODER = gql`
    mutation updateEncoder($projectId: Int64!, $encoderId: Int64!, $input: CreateEncoderInput!) {
        updateEncoder(projectId: $projectId, encoderId: $encoderId, input: $input) {
            id
            name
            protocol_id
            function_id
            Parameters
            project_id
        }
    }
`;

export const DELETE_ENCODER = gql`
    mutation deleteEncoder($projectId: Int64!, $encoderId: Int64!) {
        deleteEncoder(projectId: $projectId, encoderId: $encoderId) {
            id
        }
    }
`;

export const CAPABILITY_ENCODERS = gql`
    query capabilityEncoders($projectId: Int64!, $deviceTypeId: Int!) {
        capabilityEncoders(projectId: $projectId, deviceTypeId: $deviceTypeId) {
            id
            capability_id
            encoder_id
            device_type_id
            version_id
            capability {
                id
                name
            }
        }
    }
`;

export const STORE_CAPABILITY_ENCODER = gql`
    mutation storeCapabilityEncoder($projectId: Int64!, $capabilityId: Int64!, $input: CapabilityEncoderInput!) {
        storeCapabilityEncoder(projectId: $projectId, capabilityId: $capabilityId, input: $input) {
            id
            capability_id
            encoder_id
            device_type_id
            version_id
        }
    }
`;

export const DELETE_CAPABILITY_ENCODER = gql`
    mutation deleteCapabilityEncoder($projectId: Int64!, $capabilityId: Int64!, $capabilityEncoderId: Int64!) {
        deleteCapabilityEncoder(projectId: $projectId, capabilityId: $capabilityId, capabilityEncoderId: $capabilityEncoderId) {
            id
        }
    }
`;
